<script setup>
import ColorPicker from '../../../../components-next/colorpicker/ColorPicker.vue';

defineProps({
  // Alinhado com o ColorPicker que este componente envolve (default: ''). Era
  // `required: true`, mais rígido que o primitivo — e estágio legado gravado sem
  // `color` chega como undefined, o que produzia um warning de prop para CADA
  // estágio sem cor toda vez que o formulário de funil abria.
  modelValue: {
    type: String,
    default: '',
  },
  ariaLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div
    class="w-full [&_.relative]:w-full [&_button]:min-h-11 [&_button]:w-full"
    @click.stop
  >
    <ColorPicker
      :model-value="modelValue"
      :aria-label="ariaLabel"
      class="!w-full"
      @update:model-value="color => emit('update:modelValue', color)"
    />
  </div>
</template>
